<template>
  <div class="navbar-container d-flex content align-items-center">

    <LogoNavBar class="logo-icon"/>

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav icon-menu d-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <IconMenu/>
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-flex horizontal-menu">
      <div class="icon-navbar">
        <IconApontamentos class="icon-apontamentos" v-b-tooltip.hover.bottomright title="Apontamentos e Apropriação Horas" @click="$router.push({ name: 'apontamentos' })"/>
      </div>
        

      <div class="line"/>
      
      <div  class="header-navbar navbar-horizontal" v-if="pcpAccess">
        <horizontal-nav-menu />
      </div>
      
    </div>

    
    <b-navbar-nav class="nav align-items-center ml-auto ">

      <IconApontamentos class="icon-apontamentos tablet d-none " v-b-tooltip.hover.bottomright title="Apontamentos e Apropriação Horas" @click="$router.push({ name: 'apontamentos' })"/>

      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class=" d-flex user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData.first_name }} {{ userData.last_name }}
            </p>
            <span class="user-status">{{ userData.job_role }}</span>
          </div>

          <b-avatar
            class="user-photo"
            v-if="userData.photo"
            size="40"
            variant="light-primary"
            :src="userData.photo"
          />

          <b-avatar variant="light-secondary" v-else>
            <span>{{ userData.first_name.substring(0,1).toUpperCase() }}{{ userData.last_name.substring(0,1).toUpperCase() }}</span>
          </b-avatar>
        </template>

        

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <IconLogout/>
          <span>{{$t("Logout")}}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'

import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, VBTooltip
} from 'bootstrap-vue'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import LogoNavBar from '../../assets/images/logo/logo-navbar-icon.svg'
import HorizontalNavMenu from '../../../src/@core/layouts/layout-horizontal/components/horizontal-nav-menu/HorizontalNavMenu.vue'
import IconProfile from '@/assets/images/pages/profile-icon.svg'
import IconSupport from '@/assets/images/pages/support-icon.svg'
import IconLogout from '@/assets/images/pages/logout-icon.svg'
import IconMenu from '@/assets/images/pages/menu-icon.svg'
import IconApontamentos from '@/assets/images/pages/apontamentos-icon.svg'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    VBTooltip,


    // Navbar Components
    Locale,
    LogoNavBar,
    HorizontalNavMenu,
    IconProfile,
    IconSupport,
    IconLogout,
    IconMenu,
    IconApontamentos
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data(){
    return {
      userData : JSON.parse(localStorage.getItem('userData')),
      prefix: localStorage.getItem('prefix') || this.$router.currentRoute.params.prefix, 
      pcpAccess: JSON.parse(localStorage.getItem('userData')).ability.find( element => element.action === 'manage') || JSON.parse(localStorage.getItem('userData')).ability.find( element => element.subject === 'pcp')
    }
  },
  methods: {
    logout(){
      useJwt.logout(this.$router.currentRoute.params.prefix).then(response =>{
          localStorage.removeItem('userData')
          localStorage.removeItem('sites')

          // Reset ability
          this.$ability.update(initialAbility)

          // Redirect to login page
          this.$router.push({ name: 'login' }).catch(() => {});
      }).catch(error => {
          // Remove accessToken from localStorage
          localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)

          // Remove userData from localStorage
          localStorage.removeItem('userData')
          localStorage.removeItem('sites')

          // Reset ability
          this.$ability.update(initialAbility)
           
          // Redirect to login page
          this.$router.push({ name: 'login' })
      })
    },
    toggleOperatorMode(){
      // this.isNavMenuHidden = !this.isNavMenuHidden
      return this.$route.name.split('-')[0] == 'operator' ? this.$router.push({name: 'home', params: {prefix: this.prefix}}) : this.$router.push({name: 'operator', params: {prefix: this.prefix}})
    },
  },
  setup() {
    const { skin, isNavMenuHidden } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')

    return { skin, isDark, isNavMenuHidden }
  },
}
</script>
<style lang="scss" >
.navbar {
  .navbar-container{
    .dropdown-user{
      margin-left: 26px;
      .nav-link{
        padding: 0 !important;
        .user-name{
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 400 !important;
          font-size: 14px;
          line-height: 20px;
          color: #4C4541;
        }
        .user-status{
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 400 !important;
          font-size: 12px;
          line-height: 16px;
          color: #998F8A;
        }
        .user-photo{
          width: 38px !important;
          height: 38px !important;
        }
      }
      .dropdown-menu{
        .nav-locale{
          flex-direction: column;
          &.en{
            .nav-link{
              left: -28px !important;
            }
          }
          .nav-link{
            left: -14px;
            svg{
              right: -25px;
              top: 1px !important;
            }
          }
          .dropdown-menu{
           background: transparent;
           width: 80%;
           top: 5px;
           left: -8px !important;
            .item-locale{
              a{
               background: transparent !important;
              }
              
            }
          }
        }
        .dropdown-item{
          span{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #998F8A;
            margin-left: 9px;
          }
          svg{
            path{
              fill: #998F8A;
            }
          }
          &:hover{
            background-color: #FFEDE2;
            span{
              color: #974900;
            }
            svg{
              path{
                fill: #974900 !important;
              }
            }
            a{
              span{
                color: #974900 !important;
              }
            }
          }
          .nav-link{
            padding: 0;
          }
        }
      }
    }
    .bookmark-wrapper{

      .icon-navbar{
        padding: 9px 12px;
        margin-left: 14px;
        &:hover{
          border-radius: 5px;
          background-color: #FFEDE2;
          svg{
            path{
              fill: #974900;
            }
          }
        }
      }
      .line{
        width: 2px;
        height: 30px;
        background: #ECE0DB;
        margin: 0 14px;
      }
      .header-navbar.navbar-horizontal{
        .navbar-container{
          padding: 0 !important;
          .nav-item{
            padding: 0 !important;
            &:hover{
              .nav-link{
                background: #FFEDE2 !important;
              }
              span{
                color: #974900 !important;
              }
              svg{
                path{
                  fill: #974900 !important;
                }
              }
            }
            &.active{
              .nav-link{
                background: #974900 !important;
                box-shadow:none !important;
              }
              span{
                color: #ffff !important;
              }
              svg{
                path{
                  fill: #ffff !important;
                }
              }
              .dropdown-menu{
                .active{
                  a{
                    background-color: #FFDBC4 !important;
                    span{
                      color: #974900 !important;
                    }
                    svg{
                      path{
                        fill:#974900 !important;;
                      }
                    }
                  }
                }
                
              }
            }
            &:focus{
              .nav-link{
                background: #FFDBC4 !important;
              }
              span{
                color: #974900 !important;
              }
              svg{
                path{
                  fill: #974900 !important;
                }
              }
            }
            .nav-link{
              display: flex;
              align-items:center !important;
              svg{
                path{
                  fill: #998F8A ;
                }
              }
              span{
                color:#998F8A;
                font-family: 'Roboto';
                font-style: normal;
                font-weight: 600;
                font-size: 14px;
                line-height: 20px;
              }
            }
            .dropdown-menu{
              margin: 0 !important;
              padding: 0;
              box-shadow: none !important;
              background-color: transparent !important;
              ul{
                padding: 8px 0 !important;
                box-shadow: 0 5px 25px rgb(34 41 47 / 10%);
                margin-top: 4px;
                background-color: #ffff !important;
                border-radius: 6px ;
                .dropdown-item{
                  span{
                    color: #998F8A !important;
                  }
                  svg{
                    path{
                      fill: #998F8A !important;
                    }
                  }
                  &:hover{
                    background-color: #FFEDE2 !important;
                    .ooe-icon{
                      path{
                        stroke: #974900;
                      }
                    }
                    span{
                      color: #974900 !important;
                    }
                    svg{
                      path{
                        fill:#974900 !important;
                      }
                      
                    }
                  }
                  &:focus{
                    background-color: #FFDBC4 !important;
                    span{
                      color: #974900 !important;
                    }
                    svg{
                      path{
                        fill:#974900 !important;;
                      }
                      
                    }
                  }
                }
                .dropdown-menu{
                  box-shadow: 0 5px 25px rgb(34 41 47 / 10%) !important;
                }
              }
            }
          }
        }
      }
    }
  }
}
.tooltip {
  top: 3px !important;
  .tooltip-inner{
  max-width: 250px !important;
  }
}

@media (max-width: 1024px) {
  .logo-icon{
    display: none;
  }
  .icon-menu{
    display: block !important;
  }
  .horizontal-menu{
    display: none !important;
  }
  .icon-apontamentos.tablet{
    display: block !important;
  }
}

@media (max-width: 480px) {

  .icon-apontamentos.tablet{
    display: none !important;
  }
}




</style>